import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Info */}
          <div className="space-y-8">
            <div>
              <div className="inline-block px-4 py-2 bg-orange-100 rounded-full mb-4">
                <span className="text-sm font-semibold text-orange-700">Get In Touch</span>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Let's Connect
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed">
                Ready to explore premium mandarin processing solutions? Contact our team for inquiries, partnerships, or product information.
              </p>
            </div>

            {/* Contact Cards */}
            <div className="space-y-4">
              {/* Phone */}
              <a
                href="tel:+385955826542"
                className="group flex items-start gap-4 p-6 bg-gradient-to-br from-orange-50 to-orange-100/50 rounded-2xl hover:from-orange-100 hover:to-orange-200/50 transition-all border border-orange-200"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-orange-700 mb-1">Phone</div>
                  <div className="text-lg font-bold text-gray-900 group-hover:text-orange-600 transition-colors">+385 95 582 6542</div>
                </div>
              </a>

              {/* Email */}
              <a
                href="mailto:info@croman.eu"
                className="group flex items-start gap-4 p-6 bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-2xl hover:from-blue-100 hover:to-blue-200/50 transition-all border border-blue-200"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg group-hover:scale-110 transition-transform">
                  <Mail className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-blue-700 mb-1">Email</div>
                  <div className="text-lg font-bold text-gray-900 group-hover:text-blue-600 transition-colors break-all">info@croman.eu</div>
                </div>
              </a>

              {/* Location */}
              <div className="flex items-start gap-4 p-6 bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-2xl border border-gray-200">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-600 to-gray-700 rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-700 mb-1">Location</div>
                  <div className="text-lg font-bold text-gray-900">Croatia</div>
                  <div className="text-sm text-gray-600 mt-1">Premium mandarin processing facility</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Visual */}
          <div className="relative">
            <div className="relative z-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-12 shadow-2xl">
              <div className="text-white space-y-6">
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm mb-6">
                  <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <h3 className="text-3xl font-bold">Ready to Start?</h3>
                <p className="text-orange-100 text-lg leading-relaxed">
                  Whether you're looking for product samples, technical specifications, or partnership opportunities, we're here to help.
                </p>
                <div className="pt-6 space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                    <span className="text-orange-100">Fast response time</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                    <span className="text-orange-100">Expert consultation</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full"></div>
                    <span className="text-orange-100">Custom solutions</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Background decoration */}
            <div className="absolute top-8 right-8 w-full h-full bg-blue-500 rounded-3xl -z-10 transform rotate-3"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;